<template>
  <div
    v-if="score"
    class="flex small-star-rating"
  >
    <div
      v-for="i in parseInt(score)"
      :key="i"
      class="c-orange"
    >
      <StarByLocale :size="size" />
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'SmallStarRating',

  props: {
    score: {
      type: Number,
      required: true,
    },

    size: {
      type: Number,
      default: 15,
    },
  },
})
</script>

<style lang="scss" scoped>
.star {
  width: 100%;
  height: auto;
}
</style>
